import React, { useEffect, useState } from "react";
import Search from "../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Table, Tooltip } from "antd";
import svg27 from "../../../assets/svg/svg27.svg";
import svg15 from "../../../assets/svg/svg15.svg";
import svg12 from "../../../assets/svg/svg12.svg";
import BreadCrumb from "../../../layout/BreadCrumb";
import CardLoading from "../../../components/CardLoading";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { fetchData } from "../../../features/fetch/fetchSlice";
import { cashConverter, formatText } from "../../../utils";
import { setActiveObj } from "../../../features/obj/objSlice";
import moment from "moment";

function GeneralTable({status,tabKey}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const url = "api/v2/flid/projects/get";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));
  const { activeObjFarmers } = useSelector((state) => ({
    activeObjFarmers: state.obj.activeObj["farmers"],
  }));
    const { refetchKey } = useSelector((state) => state.global);

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        projectName: e.target.value == "" ? null : e.target.value,
        limit: null,
        start: 0,
        projectId: null,
        countyName: null,
        projectStatus: status,
        usrId: null,
      })
    );
  };

  const handleEdit = async () => {
    await dispatch(setActiveObj({ key: "expressions", data: prodd }));
    await navigate("/expression-add");
  };
  const handleAdd = async () => {
    await dispatch(setActiveObj({ key: "expressions", data: {} }));
    await navigate("/expression-add");
  };
  const handleView = async () => {
    await dispatch(setActiveObj({ key: "expressions", data: prodd }));
    await navigate("/expression-isp-list");
  };
  const handleViewName = async (item) => {
    await dispatch(setActiveObj({ key: "expressions", data: item }));
    await navigate("/expression-isp-list");
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4">
            <img src={svg12} alt="svg12" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleView}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4">
            <img src={svg15} alt="svg15" /> View
          </Link>
        </div>
      ),
    },
  ];

  const truncateText = (text, maxLength) => {
    if (text?.length > maxLength) {
      return text?.substring(0, maxLength - 3) + "...";
    }
    return text;
  };


  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
  
    {
      title: "Farmer", 
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.farmerName}
          </div>
        );
      },
      sorter: (a, b) => a.farmerName.localeCompare(b.farmerName),
    },
    {
      title: "Description",
      render: (item) => {
        return (
          <>
            <Tooltip title={item}>
              <div className="">{truncateText(item, 35)}</div>
            </Tooltip>
          </>
        );
      },
      dataIndex: "projectDescription",
      sorter: (a, b) => a.projectDescription.localeCompare(b.projectDescription),
    },
    {
      title: "Date Registered",
      dataIndex: "createdDate",
      render: (text) =>
        text ? moment(text).format("DD-MM-YYYY HH:mm:ss") : "--",
      sorter: (a, b) =>
        moment(a.createdDate).valueOf() - moment(b.createdDate).valueOf(),
    },
    {
      title: "County",
      dataIndex: "countyName",
      sorter: (a, b) => a.countyName.localeCompare(b.countyName),
    },
    {
      title: "Location",
      dataIndex: "location",
      sorter: (a, b) => a.location.localeCompare(b.location),
    },
    {
      title: "Farm Size (Acres)",
      dataIndex: "landSize",
      sorter: (a, b) => a.landSize - b.landSize,
    },
    {
      title: "Cost",
      dataIndex: "estimatedCost",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.estimatedCost - b.estimatedCost,
    },
    {
      title: "Status",
      dataIndex: "projectStatus",
      width:'120px',
      render: (item) => {
        const colors = {  
          VERIFIED:'#B1E17C',
          INSTALLED:'#7DACDC',
          ACCEPTED:'#E1D77C',   
          PUBLISHED:'#B1E17C'
        };

        return (
          <div
            className={`${item === 'PUBLISHED' || item === 'VERIFIED' ? 'text-black' : 'text-white'} inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]`}
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        projectName: null,
        projectId: null,
        countyName: null,
        projectStatus: status,
      })
    );
  }
  
  useEffect(() => {
    if (refetchKey === tabKey) {
      fetchTableData();
    }
  }, [refetchKey]);

  

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div>
      <Table
        rowSelection={false}
        className="w-full"
        scroll={{
          x: 1200,
        }}
        rowKey={(record) => record?.projectId}
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{
          position: ["bottomRight"],
          current: pageIndex + 1,
          total: count,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPageIndex(page - 1);
            setPageSize(size);
            fetchTableData(page - 1, size);
          },
          showSizeChanger: false,
          hideOnSinglePage: true,
        }}
      />
    </div>
  );
}

export default GeneralTable;
